module.exports = __webpack_public_path__ + "community2.69160b72.png";